import createModule from "../createModule"
import view from "./view"
import { Creators as ProfileCreators } from "model/profileModal"
import { Creators as DialogCreators } from "modules/dialog/model"
import { getRole } from "helpers/permissions/roles"
import { getIsSuperuserSession, getHasSolutions } from "./selectors"
import { getModel, getAccountApiAccess } from "./selectors/model"
import { Creators } from "./model"
import { get } from "lodash"
import { MODELS_QUERY, getModels } from "resources/models"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [{
    resource: "portfolios",
    as: null,
    url: ({ account }) => `/api/${account}/portfolios`,
  }, {
    ...MODELS_QUERY,
    as: null,
  }, {
    resource: "solutionsCount",
    as: null,
    url: ({ account }) => `/api/${account}/solutions/count`,
  }],
  mapStateToProps: (state, props) => ({
    accountId: state.global.selected.accountId,
    isSuperuserSession: getIsSuperuserSession(state, props),
    hasApiAccess: getAccountApiAccess(state, props),
    isSuperuser: get(state, "user.isSuperuser", false),
    role: getRole(state, props),
    multiAccounts: get(state, "user.accounts.length", 0) > 1,
    security: state.modules.portfolioRoot.security,
    factorId: state.modules.portfolioRoot.factorId,
    model: getModel(state, props),
    settingsMenuAnchor: get(state, "modules.homeLayout.settingsMenuAnchor", null),
    header: get(state, "modules.homeLayout.header"),
    models: getModels(state, props),
    sessionExpired: get(state, "user.sessionExpired"),
    hasSolutions: getHasSolutions(state),
  }),
  actions: {
    openSecurityProfile: ProfileCreators.openSecurityProfile2,
    closeSecurityProfile: ProfileCreators.closeSecurityProfile,
    closeFactorProfile: ProfileCreators.closeFactorProfile,
    openDialog: DialogCreators.open,
    ...Creators,
  },
})
